import React from "react";
import "./Switch.css";

// Checkbox nativo com role="switch": teclado (Espaco) e leitor de tela
// funcionam sem JavaScript extra; o visual de "chave" e so CSS.
const Switch = ({ id, label, description, checked, onChange }) => {
  const descriptionId = description ? `${id}-descricao` : undefined;

  return (
    <div className="switch-field">
      <input
        id={id}
        type="checkbox"
        role="switch"
        className="switch-input"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        aria-describedby={descriptionId}
      />
      <label htmlFor={id} className="switch-label">
        <span className="switch-track" aria-hidden="true">
          <span className="switch-thumb" />
        </span>
        <span className="switch-text">{label}</span>
      </label>
      {description && (
        <p id={descriptionId} className="switch-description">
          {description}
        </p>
      )}
    </div>
  );
};

export default Switch;
